import { Component, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { ControlsBaseComponent } from '../shared/components/controls-base.component';
import { JsonDynamicComponentService } from '../json-dynamic-component.service';
import { CommonUtilsService } from '../shared/common-utils.service';

@Component({
  selector: 'ra-radio-control',
  templateUrl: './radio-control.component.html',
  styleUrls: ['./radio-control.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  standalone: false,
})
export class RadioControlComponent
  extends ControlsBaseComponent
  implements OnInit
{
  constructor(
    protected jsonDynamicComponentService: JsonDynamicComponentService,
    protected commonUtils: CommonUtilsService,
  ) {
    super(jsonDynamicComponentService, commonUtils);
  }

  ngOnInit(): void {
    const control = this.parentFormGroup?.get(this.currentConfig?.property);
    if (
      this.currentConfig?.validators?.required &&
      control &&
      !(control as FormControl).hasValidator?.(Validators.required)
    ) {
      control.addValidators(Validators.required);
      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  onRadioSelectionChange(value: any) {
    const control = this.parentFormGroup?.get(
      this.currentConfig?.property,
    ) as FormControl;
    if (!control) return;
    control.setValue(value);
    control.markAsDirty();
    control.markAsTouched();
    this.onValueChanged();
  }
}
